import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import Modal, { Field, TextInput, PrimaryButton, SecondaryButton } from "@/components/FormKit";
import { toast } from "sonner";

export default function Sites() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", address: "", city: "", state: "" });

  const load = async () => setItems((await api.get("/company/sites")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/company/sites", form);
      toast.success("Site created");
      setOpen(false);
      setForm({ name: "", address: "", city: "", state: "" });
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="space-y-8" data-testid="company-sites-page">
      <PageHeader
        eyebrow="Locations"
        title="Project sites"
        description="Physical locations where your projects are being built."
        actions={<PrimaryButton onClick={() => setOpen(true)} testId="new-site-button">+ New Site</PrimaryButton>}
      />

      <DataTable
        testId="sites-table"
        columns={[
          { key: "name", label: "Site", render: (r) => <div className="font-bold">{r.name}</div> },
          { key: "address", label: "Address" },
          { key: "city", label: "City" },
          { key: "state", label: "State" },
        ]}
        rows={items}
        empty="No sites yet."
      />

      <Modal open={open} onClose={() => setOpen(false)} title="New project site">
        <form onSubmit={submit}>
          <Field label="Name"><TextInput testId="form-site-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
          <Field label="Address"><TextInput testId="form-site-address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="City"><TextInput testId="form-site-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></Field>
            <Field label="State"><TextInput testId="form-site-state" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} /></Field>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <SecondaryButton type="button" onClick={() => setOpen(false)}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" testId="submit-site">Create</PrimaryButton>
          </div>
        </form>
      </Modal>
    </div>
  );
}
